<div class="bg-th-yellow mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>
        <span class="my-auto f16 fw-bold me-2"> گزارش اجرا </span>
    </div>
</div>

<main style="direction: rtl;" class="py-4 px-2">
    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">
        <!-- از تاریخ -->
        <div class="col-12 col-md-2 position-relative">
            <label> از تاریخ </label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
            </ng-persian-datepicker>
        </div>
        <!-- تا تاریخ -->
        <div class="col-12 col-md-2 position-relative">
            <label> تا تاریخ </label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
            </ng-persian-datepicker>
        </div>
        <!-- تانکر -->
         <div class="col-12 col-md-2 position-relative">
            <label class="mb-2 text-muted">تانکر</label>
            <select class="form-select p-2" formControlName="strUnitID">
                <option class="text-center" value=""> انتخاب کنید </option>
                <option class="text-center" *ngFor="let item of tankerList" [value]="item.strUnitID">
                    {{item.strFullName}}
                </option>
            </select>
        </div>
        <!-- مشتری -->
         <div class="col-12 col-md-2 position-relative">
            <label class="mb-2 text-muted">مشتری</label>
            <select class="form-select p-2" formControlName="iTanker_WaterClient">
                <option class="text-center" [value]="-1"> انتخاب کنید </option>
                <option class="text-center" *ngFor="let item of clientList" [value]="item.iTanker_WaterClient">
                    {{item.strName}}
                </option>
            </select>
        </div>
        <!-- جستجو -->
         <div class="col-12 col-md-auto position-relative">
            <button class="w-100 btn btn-primary px-md-4" (click)="fetchReports()"> 
                جستجو    
            </button>
        </div>
    </form>

    <div class="border mt-3 p-2">
        <div class="row gx-0 gy-2 gy-md-0">
            <input type="search" class="form-control w-100" placeholder="جستجو کنید.." (input)="filterResult($event.target.value)">
        </div>
        <div class="section border mt-2" style="height:calc(100vh - 240px);overflow: auto;">
            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
                <thead>
                    <tr class="text-center">
                        <th class="text-center">#</th>
                        <th class="text-center">شماره درخواست</th>
                        <th class="text-center">وضعیت اجرا</th>
                        <th class="text-center">زمان درخواست</th>
                        <th class="text-center">زمان مدنظر برای تحویل</th>
                        <th class="text-center">زمان تحویل تانکر</th>
                        <th class="text-center">مقدار درخواستی</th>
                        <th class="text-center">مقدار تحویل داده شده</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" *ngFor="let item of reportList; let i = index">
                        <th>{{ i + 1 | faNum }}</th>
                        <td>{{ item.iTanker_DeliverySchedule | faNum }}</td>
                        <td>{{ item.strPlanType  | faNum }}</td>
                        <td>{{ item.strSaveDateTime | faNum }}</td>
                        <td>{{ item.strRequestedDeliveryTime | faNum }}</td>
                        <td>{{ item.strDeliveredTime || '—' | faNum }}</td>
                        <td>{{ item.iValue | faNum }}</td>
                        <td>{{ item.iValueDeliverd | faNum }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</main>